import { Datagrid, EditButton, List, ShowButton, TextField, TextInput } from 'react-admin';

const filters = [<TextInput key="country" label="Country code" source="country" alwaysOn />];

const CountryConfigsList = () => (
  <List exporter={false} filters={filters}>
    <Datagrid bulkActionButtons={false} rowClick="show" optimized>
      <TextField source="country" label="Country" />
      <TextField source="cssUrl" label="CSS URL" emptyText="—" />
      <TextField source="payrollUrl" label="Payroll URL" emptyText="—" />
      <TextField source="payrollUrlAuthStrategy" label="Auth Strategy" emptyText="—" />
      <ShowButton />
      <EditButton />
    </Datagrid>
  </List>
);

export default CountryConfigsList;
